/**
 * Route → i18n-sleutel van de paginanaam. Gebruikt door het kruimelpad
 * (AppTopbar) en door de supportpagina (#1777, "pagina waar je vandaan kwam").
 */
export const ROUTE_TITLES: Record<string, string> = {
  '/': 'dashboard',
  '/tree': 'tree',
  '/people': 'people',
  '/sources': 'sources',
  '/places': 'places',
  '/stories': 'stories',
  '/media': 'media',
  '/planner': 'planner',
  '/timeline': 'timeline',
  '/reports': 'reports',
  '/family-sheet': 'familyGroupSheet',
  '/relationships': 'relationshipCalculator',
  '/quality': 'dataQuality',
  '/import': 'importExport',
  '/audit': 'activity',
  '/account': 'privacy',
  '/roadmap': 'roadmap',
  '/privacy': 'privacyPolicy',
  '/terms': 'termsOfService',
  '/analyse': 'statistics',
  '/deleted': 'deletedItems',
  '/support': 'support',
  // #1846 — zonder deze regel heette /organisatie in het kruimelpad en de sr-only h1 "Dashboard".
  '/organisatie': 'organization',
};
